import type { GetCurrentUserQuery } from 'shared/data/queries.generated'
import { useMemo } from 'react'

type Viewer = GetCurrentUserQuery['viewer']

export function useViewerCanAddSsoUser(
  viewer: Viewer | null | undefined
): boolean {
  return useMemo(
    () => !!viewer?.viewerCanAddMicrosoftSSOUser,
    [viewer?.viewerCanAddMicrosoftSSOUser]
  )
}
